import React from 'react';

const CardCompraSaldo = ({ imagen, valor, moneda, funcion }) => {
  return (
    <div
      className="bg-bgContenedorOscuro border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-lg rounded-lg p-6 flex flex-col items-center transform transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-[0_0_40px_rgba(100,116,139,1)] cursor-pointer"
      onClick={funcion}
    >
      <h2 className="text-yellow-500 text-lg font-bold mb-2">${valor} ({moneda})</h2>
      <img src={imagen} alt="Item" className="w-52 object-cover mb-4" />
    </div>
  );
};

export default CardCompraSaldo;